export const SELF_PAYER_IDENTIFIER = 'PACJENT-PLATNIK';
